export default __webpack_public_path__ + "static/media/RobinDick.f7f58605.PNG";